import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CloudDrizzleIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9.50019 0.0143373C5.59012 -0.20584 1.9865 2.12775 0.587786 5.78571C-0.810924 9.44368 0.316386 13.5862 3.37582 16.031C3.80727 16.3758 4.43653 16.3055 4.7813 15.8741C5.12607 15.4426 5.0558 14.8134 4.62435 14.4686C2.24479 12.5671 1.36799 9.3451 2.45588 6.50002C3.54376 3.65494 6.34658 1.83992 9.38774 2.01117C12.4289 2.18242 15.0102 4.30062 15.7718 7.24985C15.8859 7.69135 16.2841 7.99981 16.7401 7.99981H17.9993C19.8914 8.00222 21.5231 9.33011 21.9098 11.1824C22.2965 13.0347 21.3323 14.9047 19.5989 15.6638C19.093 15.8854 18.8625 16.4751 19.0841 16.981C19.3056 17.4869 19.8954 17.7174 20.4013 17.4958C23.0013 16.3571 24.4476 13.5522 23.8676 10.7736C23.2875 7.99508 20.8397 6.00315 18.0013 5.99981H17.4796C16.2801 2.60299 13.1473 0.21971 9.50019 0.0143373Z"
        fill={iconColor}
      />
      <Path
        d="M8 11.9998C8.55229 11.9998 9 12.4475 9 12.9998V14.9998C9 15.5521 8.55229 15.9998 8 15.9998C7.44772 15.9998 7 15.5521 7 14.9998V12.9998C7 12.4475 7.44772 11.9998 8 11.9998Z"
        fill={iconColor}
      />
      <Path
        d="M8 17.9998C8.55229 17.9998 9 18.4475 9 18.9998V20.9998C9 21.5521 8.55229 21.9998 8 21.9998C7.44772 21.9998 7 21.5521 7 20.9998V18.9998C7 18.4475 7.44772 17.9998 8 17.9998Z"
        fill={iconColor}
      />
      <Path
        d="M17 18.9998C17 18.4475 16.5523 17.9998 16 17.9998C15.4477 17.9998 15 18.4475 15 18.9998V20.9998C15 21.5521 15.4477 21.9998 16 21.9998C16.5523 21.9998 17 21.5521 17 20.9998V18.9998Z"
        fill={iconColor}
      />
      <Path
        d="M16 11.9998C16.5523 11.9998 17 12.4475 17 12.9998V14.9998C17 15.5521 16.5523 15.9998 16 15.9998C15.4477 15.9998 15 15.5521 15 14.9998V12.9998C15 12.4475 15.4477 11.9998 16 11.9998Z"
        fill={iconColor}
      />
      <Path
        d="M13 20.9998C13 20.4475 12.5523 19.9998 12 19.9998C11.4477 19.9998 11 20.4475 11 20.9998V22.9998C11 23.5521 11.4477 23.9998 12 23.9998C12.5523 23.9998 13 23.5521 13 22.9998V20.9998Z"
        fill={iconColor}
      />
      <Path
        d="M12 13.9998C12.5523 13.9998 13 14.4475 13 14.9998V16.9998C13 17.5521 12.5523 17.9998 12 17.9998C11.4477 17.9998 11 17.5521 11 16.9998V14.9998C11 14.4475 11.4477 13.9998 12 13.9998Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CloudDrizzleIcon = assignWithoutSideEffects(_CloudDrizzleIcon, {
  componentId: 'CloudDrizzleIcon',
});

export default CloudDrizzleIcon;
